<script>
    import BrakTemplate from "./components/template/BrakTemplate.svelte";
    import LoginToken from "./components/page/LoginToken.svelte";
    import {currentPage} from "./stores.js";
    import {onMount} from "svelte";

    onMount(() => {
        if ($currentPage === null) {
            currentPage.set(LoginToken);
        }
    });

    $effect(() => {
        $currentPage;
        window.dispatchEvent(new CustomEvent('currentPageChanged'));
    });

    let CurrentPage = $derived($currentPage);
</script>

<BrakTemplate>
    {#if CurrentPage}
        <CurrentPage />
    {/if}
</BrakTemplate>
